export default "__VITE_ASSET__DaIvf5f6__"